import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Shuffle = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M16.7929 4.70706L18.0858 5.99995H14.9806C14.3731 5.99995 13.7984 6.27613 13.4189 6.75056L10.5 10.3992L7.58111 6.75056C7.20157 6.27613 6.62694 5.99995 6.01938 5.99995H2V7.99995H6.01938L9.21938 12L6.01938 16H2V18H6.01938C6.62694 18 7.20157 17.7238 7.58111 17.2493L10.5 13.6007L13.4189 17.2493C13.7984 17.7238 14.3731 18 14.9806 18H18.0858L16.7929 19.2928L18.2071 20.7071L21.9142 17L18.2071 13.2928L16.7929 14.7071L18.0858 16H14.9806L11.7806 12L14.9806 7.99995H18.0858L16.7929 9.29285L18.2071 10.7071L21.9142 6.99995L18.2071 3.29285L16.7929 4.70706Z"
      fill="currentColor"
    />
  </Icon>
));

export default Shuffle;
